import React from "react";
import { FolderIcon } from "@common/folderIcon";
import { useProjectStatusesRetrieval } from "@planzone/view-models";
import { useTranslation } from "react-i18next";

import { Props } from "./types";
import styles from "./styles.scss";
import { SelectedIcon } from "./selectedIcon";

function StatusList({ project, selectStatus }: Props) {
  const { t } = useTranslation();
  const {
    isRequestPending,
    isRequestSuccess,
    isRequestFailure,
    statuses,
    retrieveProjectStatuses,
  } = useProjectStatusesRetrieval();

  const isCustomStatus = (status: string) => {
    return (
      status !== "pz_closed" &&
      status !== "pz_waiting" &&
      status !== "pz_candidate" &&
      status !== "pz_open"
    );
  };

  React.useEffect(() => {
    !isRequestPending &&
      !isRequestSuccess &&
      !isRequestFailure &&
      retrieveProjectStatuses();
  }, []);

  return (
    <div className={styles.statusList}>
      <div className={styles.section}>
        {statuses
          .filter((status) => !isCustomStatus(status.label))
          .map((status) => (
            <div
              key={status.uuid}
              className={styles.status}
              onClick={() => selectStatus(status)}
            >
              <div className={styles.topElement}>
                <div className={styles.folder}>
                  <FolderIcon
                    className={styles.folderIcon}
                    style={{ fill: status.color }}
                    isOpen={false}
                  />
                  <p className={styles.name}>
                    {t(`projectStatuses.${status.label}`, status.label)}
                  </p>
                </div>
                {project.status.uuid === status.uuid && (
                  <div>
                    <SelectedIcon
                      style={{ fill: status.color }}
                      className={styles.icon}
                    />
                  </div>
                )}
              </div>
              <p className={styles.description}>
                {t(`projectStatuses.description.${status.label}`, status.label)}
              </p>
            </div>
          ))}
      </div>
      <div className={styles.section}>
        {statuses
          .filter((status) => isCustomStatus(status.label))
          .map((status) => (
            <div
              key={status.uuid}
              className={styles.status}
              onClick={() => selectStatus(status)}
            >
              <div className={styles.topElement}>
                <div className={styles.folder}>
                  <FolderIcon
                    className={styles.folderIcon}
                    style={{ fill: status.color }}
                    isOpen={false}
                  />
                  <p className={styles.name}>
                    {t(`projectStatuses.${status.label}`, status.label)}
                  </p>
                </div>
                {project.status.uuid === status.uuid && (
                  <div>
                    <SelectedIcon
                      style={{ fill: status.color }}
                      className={styles.icon}
                    />
                  </div>
                )}
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}

export { StatusList };
